import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
  CircularProgress,
  IconButton,
  InputAdornment,
  Paper,
  FormHelperText,
} from "@material-ui/core";
import React, { useState } from "react";
import mainStyles from "../../styles/mainStyles";
import { useMediaQuery } from "react-responsive";
import { Helmet } from "react-helmet";
import ForgetImage from "../../assets/images/forget-password-illustration.svg";
import PageContainer from "../../components/PageContainer";
import { useHistory } from "react-router-dom";
import applicantApi from "../../redux/api/applicant";
import { VisibilityOff } from "@material-ui/icons";
import { Visibility } from "@material-ui/icons";
import CongratsImg from "../../assets/images/congrats.svg";
import AlertComponent from "../../components/Applicant/AlertComponent";
import adminApi from "../../redux/api/admin";

const AdminResetPassword = (props) => {
  const history = useHistory();
  const isPhone = useMediaQuery({ query: "(max-width: 812px)" });

  const defAlertDetails = {
    image: CongratsImg,
    headerText: "Congratulations!",
    text: "Password change was successful.",
    btn2Text: "Proceed to login",
  };

  const [openModal, setOpenModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleCloseModal = () => {
    history.push("/admin/login");
  };

  const [alertConfig, setAlertConfig] = useState(defAlertDetails);

  const [resetForm, setResetForm] = useState({
    token: "",
    password: "",
    password_confirm: "",
  });

  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleFormChange = ({ name, value }) => {
    setFormError("");
    setResetForm({ ...resetForm, [name]: value });
  };
  const resetApplicantHandler = async (e) => {
    e.preventDefault();
    setFormError("");

    setLoading(true);
    try {
      const res = await adminApi.resetPassword(resetForm);
      console.log(res);
      setOpenModal(true);
      // history.push("/applicant/login");
    } catch (err) {
      console.log(err);
      setFormError(err.data.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer>
      <Container
        style={isPhone ? mainStyles.phoneContainer : mainStyles.container}
      >
        <Helmet>
          <title>Reset Password | NTI</title>
        </Helmet>

        <Box
          className="slide-box"
          style={isPhone ? {} : { margin: "20px 100px" }}
        >
          <Paper elevation={5}>
            <Grid
              className="log-div"
              style={{
                ...mainStyles.subContainer,
                ...{ padding: "30px 50px" },
              }}
            >
              <Grid
                className="log-grid"
                item
                xs={12}
                sm={6}
                style={{
                  borderRadius: "10px 0 0 10px",
                  padding: "30px 60px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img alt="" src={ForgetImage} />
              </Grid>

              <Grid item xs={12} sm={6} style={{ padding: "20px 15px" }}>
                <Typography
                  className="login-main"
                  style={{
                    fontWeight: 500,
                    fontSize: "30px",
                    margin: "5%",
                    marginBottom: ".5rem",
                  }}
                >
                  Reset Password
                </Typography>
                <Typography
                  className="log-sub"
                  style={{
                    fontWeight: 400,
                    fontSize: "16px",
                    color: "#9F9F9F",
                    marginLeft: "5%",
                    marginRight: "5%",
                  }}
                >
                  Enter the token that was sent to your email, enter new
                  password and comfirm new password
                </Typography>
                <form onSubmit={(e) => resetApplicantHandler(e)}>
                  <Grid item style={mainStyles.inputGrid}>
                    <TextField
                      label="Token"
                      name="token"
                      type="token"
                      style={mainStyles.input}
                      variant="outlined"
                      onChange={(e) => handleFormChange(e.target)}
                    />
                  </Grid>
                  <Grid item xs={12} style={mainStyles.inputGrid}>
                    <TextField
                      label="Password"
                      style={mainStyles.input}
                      variant="outlined"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={resetForm.password}
                      onChange={(e) => handleFormChange(e.target)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                              edge="end"
                            >
                              {!showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} style={mainStyles.inputGrid}>
                    <TextField
                      label="Password"
                      style={mainStyles.input}
                      variant="outlined"
                      type={showConfirm ? "text" : "password"}
                      name="password_confirm"
                      value={resetForm.password_confirm}
                      onChange={(e) => handleFormChange(e.target)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowConfirm(!showConfirm)}
                              edge="end"
                            >
                              {!showConfirm ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <FormHelperText
                      error
                      style={{ textAlign: "center", marginBottom: "1rem" }}
                    >
                      {formError}
                    </FormHelperText>
                  </Grid>
                  <Grid item xs={12} style={mainStyles.inputGrid}>
                    <Box mb={6}>
                      <Button
                        fullWidth
                        style={{ height: "50px" }}
                        variant="contained"
                        color="primary"
                        type="submit"
                      >
                        {loading ? (
                          <CircularProgress color="inherit" size="15px" />
                        ) : (
                          "Reset"
                        )}
                      </Button>
                    </Box>
                  </Grid>
                </form>
              </Grid>
            </Grid>
          </Paper>
        </Box>
        <AlertComponent
          config={alertConfig}
          openDialog={openModal}
          handleAlertConfirm={handleCloseModal}
        />
      </Container>
    </PageContainer>
  );
};
export default AdminResetPassword;
